import { getRequest, postRequest } from "utils/helpers/common/http-methods";


export const COMMUNITIES_APIS = {
    getCommunities: (params: any) => getRequest('/event/communities', params)
}